export const mistakeMessage = ["ま", "ち", "が", "い", "で", "す"];
